import styled from 'styled-components';
import { css } from 'styled-components';
import PropTypes from 'prop-types';
import { shades } from 'utils';

const { neutrals } = shades;

const ButtonSize = (paddingX, paddingY, fontSize, borderRadius) =>
  css`
    padding: ${paddingX + 'px'} ${paddingY + 'px'};
    font-size: ${fontSize + 'px'};
    border-radius: ${borderRadius + 'px'};
  `;
const ButtonVariant = (background, color) => css`
  color: ${color};
  background: ${background};
  cursor: pointer;
  transition: background 0.1s ease-in;

  &:focus,
  &:hover {
  }
`;

export const Button = styled.button`
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 0;
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  ${({ uppercase }) =>
    uppercase &&
    `
  	text-transform: uppercase;
  `};

  ${props =>
    props.bold &&
    `
  	font-weight: ${props.theme.fontWeight.bold};
  `};
`;

export const RoundedButton = Button.extend`
  ${ButtonSize(8, 20, 14, 18)};
  ${ButtonVariant(shades.teals.tilicho, neutrals.shukrabaar)};
  font-weight: 600;

  &:hover,
  &:focus,
  &:active {
    background: #01887e;
  }
`;

export const OutlineButton = Button.extend`
  ${ButtonSize(8, 24, 14, 18)};
  ${ButtonVariant(neutrals.shukrabaar, shades.teals.tilicho)};
  border: 1px solid ${shades.teals.tilicho};
  transition: background-color 0.1s ease-in;
  font-weight: 600;

  &:hover,
  &:focus {
    color: #fff;
    background-color: ${shades.teals.tilicho};
  }
`;

export const SearchButton = Button.extend`
  ${ButtonSize(5, 17, 12, 12)};
  ${ButtonVariant('#ccfffb', '#4a4a4a')};
  border-radius: 14px;

  &:hover {
    background-color: #c1e2ff;
  }
`;

export const TransparentButton = Button.extend`
  ${ButtonSize(8, 8, 14, 18)};
  font-weight: 600;
  ${ButtonVariant(neutrals.shukrabaar, shades.teals.tilicho)};

  &:hover,
  &:focus {
  }
`;

Button.displayName = 'Button';

Button.propTypes = {
  uppercase: PropTypes.bool,
  bold: PropTypes.bool
};

Button.Link = Button.withComponent('a');
Button.Link.displayName = 'Button.Link';



// WEBPACK FOOTER //
// ./src/components/styled/ui/button/button.js